import { SiteItem } from "@vviinn/user-managment-client-ts";
import { siteTextNets } from "./constants";
import { TextSearchNumbericTitles } from "./types";

export const filteredTextNets = (
  siteDetails: SiteItem,
): (keyof TextSearchNumbericTitles)[] =>
  siteTextNets
    .filter(({ siteNet }) => siteDetails[siteNet])
    .map(({ net }) => net);
